import React from "react";

/**
 * Collapsible panel that renders a raw JSON object (typically a gateway/API
 * response) in a copy-friendly preformatted block. Used across the app to give
 * admins one-click access to the underlying API payload behind a txn, top-up,
 * payout, payment-link settlement or unmapped queue entry.
 *
 * Props:
 *  - data: object | null
 *  - title?: string (default "Raw gateway response")
 *  - subtitle?: string (small hint shown next to the title)
 *  - testId?: string (data-testid root)
 *  - defaultOpen?: boolean
 */
export default function RawResponsePanel({
  data,
  title = "Raw gateway response",
  subtitle = "click to expand",
  testId = "raw-response-panel",
  defaultOpen = false,
}) {
  if (!data || (typeof data === "object" && Object.keys(data).length === 0)) return null;
  return (
    <details className="surface-card p-4" open={defaultOpen} data-testid={testId}>
      <summary className="text-sm font-semibold cursor-pointer select-none flex items-center gap-2">
        <span>{title}</span>
        <span className="text-[10px] text-muted-foreground font-normal">({subtitle})</span>
      </summary>
      <pre className="mt-3 text-[11px] font-mono whitespace-pre-wrap break-all bg-background border border-border rounded p-3 max-h-72 overflow-auto">
        {JSON.stringify(data, null, 2)}
      </pre>
    </details>
  );
}
